import { MethodDescription } from '../method-description';

export const DashboardBannersClickDescription = new MethodDescription();

DashboardBannersClickDescription.name = 'dashboardBannersClick';
DashboardBannersClickDescription.fields = [
	'bannerId',
];
DashboardBannersClickDescription.usesToken = true;
